import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center py-20">
      <div className="container-max px-4 text-center">
        <div className="text-9xl md:text-[12rem] font-bold text-zwheel-black/10 mb-4">
          404
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-zwheel-black mb-4">
          Página no encontrada
        </h1>
        <p className="text-lg text-zwheel-gray-600 mb-8 max-w-md mx-auto">
          La página que está buscando no existe o ha sido movida.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            asChild
            className="bg-zwheel-black hover:bg-zwheel-gray-800 text-white px-8 py-3"
          >
            <Link to="/">
              <Home className="h-4 w-4 mr-2" />
              Volver al Inicio
            </Link>
          </Button>
          <Button
            variant="outline"
            className="border-zwheel-gray-300 text-zwheel-gray-700 hover:bg-zwheel-gray-50 px-8 py-3"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Página Anterior
          </Button>
        </div>
      </div>
    </div>
  );
}

